module.exports = __webpack_public_path__ + "static/media/intro2.4c11cd3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro2.jpg
// module id = 6326
// module chunks = 0